module.exports = __webpack_public_path__ + "cfb603eef121e0cecf6ffc5136035757.png";